import { useCallback } from 'react';
import { useLang } from '../util/lang';
import { ERROR } from '../util/const';

const useErrorMsg = () => {
    const get = useLang();

    const getErrorMsg = useCallback((error, defaultMsg = '') => {
        let errorMsg = defaultMsg;

        if (error.response?.data && error.response?.data.message) {
            switch (error.response.data.message) {
                case ERROR.CASE_CANCELLED:
                    errorMsg = get('@PatientInfo.msg.caseCancelledMessage');
                    break;
                default:
                    break;
            }
        }

        return errorMsg;
    }, []);

    return {
        getErrorMsg,
    };
};

export default useErrorMsg;
